"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _promoLogo = _interopRequireDefault(require("../../common/promo-logo/promo-logo"));

const Header = props => {
  const {
    className,
    logoUrl,
    children,
    link
  } = props;
  return /*#__PURE__*/_react.default.createElement("header", {
    className: (0, _classnames.default)('header', className)
  }, /*#__PURE__*/_react.default.createElement(_promoLogo.default, {
    url: logoUrl,
    link: link,
    className: "header__logo"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "header__content"
  }, children));
};

Header.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  logoUrl: _propTypes.default.string,
  link: _propTypes.default.func
};
Header.defaultProps = {
  children: null,
  className: '',
  logoUrl: null,
  link: null
};
var _default = Header;
exports.default = _default;